module.exports = __webpack_public_path__ + "6b80cbb650d27c0c4072b3abd9632d57.svg";